<template>
	<div class="gallery-view" v-if="fullScreen" @click="closeFullScreen()">
		<div class="gallery-view-full" v-if="selectedImageId">
			<fa-icon :icon="'times'" class="faicon faicon-close-fullscreen" @click="closeFullScreen()" />
			<fa-icon :icon="'angle-left'" class="faicon faicon-left" size="lg" @click="changeImageIndex($event, -1)" v-show="canGoLeft"/>
			<img :src="`/storage/media/${findInMedia(selectedImageId).original_name}`" />
			<fa-icon :icon="'angle-right'" class="faicon faicon-right" size="lg" @click="changeImageIndex($event, 1)" v-show="canGoRight"/>
		</div>
	</div>
</template>

<script>
import contentDataLoader from '@/store/modules/contentData/content-data-loader';
import staticDataLoader from '@/store/modules/staticData/static-data-loader';
import { mapActions, mapState } from 'vuex';

export default {
	mixins: [contentDataLoader, staticDataLoader],
	computed: {
		...mapState('gallery', ['selectedImageId', 'fullScreen', 'gallery']),
		imagesInGallery() {
			return this.gallery.fields.data.length;
		},
		canGoLeft() {
			return this.gallery.fields.data.indexOf(this.selectedImageId) > 0;
		},
		canGoRight() {
			return this.gallery.fields.data.indexOf(this.selectedImageId) < this.imagesInGallery - 1;
		},
	},
	methods: {
		...mapActions('gallery', ['setFullScreen', 'setSelectedImage']),
		closeFullScreen() {
			this.setFullScreen(false);
		},
		changeImageIndex(e, modifier) {
			e.preventDefault();
			e.stopPropagation();
			const currentIdx = this.gallery.fields.data.indexOf(this.selectedImageId);
			let newImageIdx = currentIdx + modifier;
			if (newImageIdx < 0) {
				newImageIdx = 0;
			} else if (newImageIdx > this.imagesInGallery - 1) {
				newImageIdx = this.imagesInGallery - 1;
			}
			this.setSelectedImage(this.gallery.fields.data[newImageIdx]);
		},
	},
};
</script>

<style src="@/styles/components/GalleryView/GalleryView.less" lang="less" scoped></style>
